import React from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  ChartBody,
  ChartHeader,
  ChartTitle,
  ChartWrapper,
  LegendDot,
} from "../styles/UsageChartStyles";

const UsageChart = ({ data = [], dataKey, title, color, expanded = false }) => {
  const validData = data.filter(
    (item) =>
      item &&
      typeof item[dataKey] === "number" &&
      Number.isFinite(item[dataKey])
  );

  return (
    <ChartWrapper
      $expanded={expanded}
      role="img"
      aria-label={`Gráfico de ${title} da última hora`}
    >
      <ChartHeader $expanded={expanded}>
        <ChartTitle $expanded={expanded}>{title}</ChartTitle>
        <LegendDot $color={color} $expanded={expanded} aria-hidden="true" />
      </ChartHeader>
      <ChartBody>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={validData}
            margin={
              expanded
                ? { top: 8, right: 10, bottom: 2, left: 0 }
                : { top: 4, right: 4, bottom: 0, left: 0 }
            }
          >
            <CartesianGrid
              strokeDasharray="2 3"
              stroke="#263b47"
              vertical={false}
            />
            <XAxis
              dataKey="time"
              tick={{ fontSize: expanded ? 12 : 6, fill: "#aab5bf" }}
              tickLine={false}
              tickSize={0}
              tickMargin={expanded ? 8 : 1}
              axisLine={{ stroke: "#4a5661" }}
              minTickGap={expanded ? 28 : 12}
              height={expanded ? 24 : 10}
            />
            <YAxis
              domain={[0, 120]}
              ticks={[0, 50, 100]}
              interval={0}
              tickFormatter={(value) => `${value}%`}
              tick={{ fontSize: expanded ? 11 : 6, fill: "#c1c9d0" }}
              tickLine={false}
              tickSize={0}
              tickMargin={expanded ? 5 : 1}
              axisLine={expanded ? { stroke: "#4a5661" } : false}
              width={expanded ? 42 : 24}
            />
            <Tooltip
              formatter={(value) => [
                `${Number(value).toLocaleString("pt-BR", {
                  maximumFractionDigits: 1,
                })}%`,
                title,
              ]}
              labelStyle={{
                color: "#f5f7f9",
                fontSize: "12px",
                fontWeight: 700,
              }}
              itemStyle={{ color, fontSize: "12px" }}
              contentStyle={{
                backgroundColor: "#0d141a",
                border: "1px solid #34414c",
                borderRadius: "9px",
                boxShadow: "0 12px 28px rgba(0, 0, 0, 0.35)",
              }}
              cursor={{ stroke: "#65717d", strokeDasharray: "3 3" }}
            />
            <Line
              type="monotone"
              dataKey={dataKey}
              stroke={color}
              strokeWidth={expanded ? 2.2 : 1.6}
              strokeLinecap="round"
              strokeLinejoin="round"
              dot={false}
              activeDot={{
                r: expanded ? 4 : 2.5,
                fill: color,
                stroke: "#0d141a",
                strokeWidth: expanded ? 2 : 1,
              }}
              isAnimationActive={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </ChartBody>
    </ChartWrapper>
  );
};

export default UsageChart;
